import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';

import type { Filters, Options } from 'lib/performance';
import { FilterKey } from 'lib/performance';

export const PerformanceFilters = ({
  filters,
  onFilterChange,
  options,
}: {
  filters: Filters;
  options: Options;
  onFilterChange: (key: FilterKey, value: Filters[FilterKey]) => void;
}) => {
  const {
    [FilterKey.COMPETITION]: selectedCompetition,
    [FilterKey.TEAM]: selectedTeam,
    [FilterKey.HOME_AWAY]: selectedHomeAway,
    [FilterKey.POSITION]: selectedPosition,
  } = filters;

  const {
    [FilterKey.COMPETITION]: competitions,
    [FilterKey.TEAM]: teams,
    [FilterKey.HOME_AWAY]: homeAwayOptions,
    [FilterKey.POSITION]: positions,
  } = options;

  const selectedCompetitionOption = competitions.find(
    c => c.value === selectedCompetition
  );

  const selectedTeamOption = teams.find(t => t.value === selectedTeam);

  const selectedHomeAwayOption = homeAwayOptions.find(
    h => h.value === selectedHomeAway
  );

  const selectedPositionOption = positions.find(
    p => p.value === selectedPosition
  );

  return (
    <>
      {competitions?.length > 2 && (
        <FilterInDropdown
          buttonLabel={selectedCompetitionOption?.label}
          buttonSize="compact"
        >
          {({ closeDropdown }) => (
            <RadioGroup
              modalSelect
              options={competitions}
              value={selectedCompetitionOption?.value}
              name="competitions-filter-fixture-chart"
              onChange={competition => {
                if (competition)
                  onFilterChange(FilterKey.COMPETITION, competition);
                closeDropdown();
              }}
            />
          )}
        </FilterInDropdown>
      )}
      {teams?.length > 2 && (
        <FilterInDropdown
          buttonSize="compact"
          buttonLabel={selectedTeamOption?.label}
        >
          {({ closeDropdown }) => (
            <RadioGroup
              modalSelect
              options={teams}
              value={selectedTeamOption?.value}
              name="team-filter-fixture-chart"
              onChange={team => {
                if (team) onFilterChange(FilterKey.TEAM, team);
                closeDropdown();
              }}
            />
          )}
        </FilterInDropdown>
      )}
      <FilterInDropdown
        buttonSize="compact"
        buttonLabel={selectedHomeAwayOption?.label}
      >
        {({ closeDropdown }) => (
          <RadioGroup
            modalSelect
            options={homeAwayOptions}
            value={selectedHomeAwayOption?.value}
            name="home-away-filter-fixture-chart"
            onChange={v => {
              if (v) onFilterChange(FilterKey.HOME_AWAY, v);
              closeDropdown();
            }}
          />
        )}
      </FilterInDropdown>
      {positions?.length > 1 && (
        <FilterInDropdown
          buttonSize="compact"
          buttonLabel={selectedPositionOption?.label}
        >
          {({ closeDropdown }) => (
            <RadioGroup
              modalSelect
              options={positions}
              value={selectedPositionOption?.value}
              name="position-filter-fixture-chart"
              onChange={position => {
                if (position) onFilterChange(FilterKey.POSITION, position);
                closeDropdown();
              }}
            />
          )}
        </FilterInDropdown>
      )}
    </>
  );
};
